<template>
  <el-table
    :data="data"
    v-bind="$attrs"
    v-on="$listeners"
    ref="table"
    :summary-method="getSummaries"
  >
    <!-- Accept table columns definitions in default slot -->
    <slot/>

    <button
      v-if="hasMore"
      slot="append"
      class="btn btn-gray btn-lg btn-block"
      :class="{loading}"
      style="border-radius: 0; border: 0;"
      @click="$emit('load-more')"
      ref="loadMore"
    >
      Еще
    </button>
  </el-table>
</template>

<script>
  import Vue from 'vue'
  import { Table, TableColumn } from 'element-ui'
  import scrollMonitor from 'scrollmonitor'

  Vue.use(Table)
  Vue.use(TableColumn)

  export default {
    name: 'data-table',
    props: {
      data: {
        type: Array,
      },
      hasMore: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      currencySymbol: {
        type: Array,
        default: () => [],
      },
      tableColumnType: {
        type: Array,
        default: () => [],
      },
    },
    mounted () {
      this.$nextTick(() => {
        this.initWaypoint()
      })
    },
    watch: {
      hasMore () {
        if (this.hasMore) {
          this.initWaypoint()
        } else if (this.scrollMonitor) {
          this.scrollMonitor.destroy()
          this.scrollMonitor = null
        }
      },
    },
    methods: {
      initWaypoint () {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.hasMore && this.$refs.table) {
              this.containerMonitor = this.containerMonitor || scrollMonitor.createContainer(this.$refs.table.$refs.bodyWrapper)
              this.scrollMonitor = this.containerMonitor.create(this.$refs.loadMore)

              this.scrollMonitor.enterViewport(() => this.$emit('load-more'))
              // this.scrollMonitor.exitViewport(() => {})
            }
          }, 150)
        })
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = 'Сумма';
            return;
          }
          const values = data.map(item => item[column.property]);
          const tableColumnType = this.tableColumnType[index]; // Предполагаем, что типы начинаются с 0
          if ( ['string', 'date'].includes(tableColumnType) )
          {
            sums[index] = '';
          }
          else if (values.some(value => !isNaN(parseFloat(value)) && isFinite(value))) {
            let total = values.reduce((prev, curr) => {
              const value = Number(curr);
              return !isNaN(value) ? prev + value : prev;
            }, 0);

            // Получаем символ валюты для текущего столбца
            const currencySymbol = this.currencySymbol[index]; // Предполагаем, что символы начинаются с 0
            if (currencySymbol === '₽' || currencySymbol === 'шт.')
            {
              const value = parseFloat(total)
              total = isNaN(value) ? '' : value.toLocaleString('ru', this.options)
            }
            sums[index] = currencySymbol ? `${total} ${currencySymbol}` : total; // Добавляем символ валюты
          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
    },
    beforeDestroy () {
      if (this.scrollMonitor) {
        this.scrollMonitor.destroy()
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/data-table.vue